import React, { useEffect } from 'react';
import { useAuth0 } from '../../../providers/Auth0Provider';
import LoadingIndicator from '../../core/LoadingIndicator/LoadingIndicator';

const Callback = ({ history }) => {
  const {
    isAuthenticated,
    handleRedirectCallback,
    onRedirectCallback,
    loginWithRedirect,
    loading,
  } = useAuth0();

  useEffect(() => {
    const fn = async () => {
      const currentURL = new URL(window.location.href);

      if (currentURL.searchParams.get('error')) {
        const errorMsg = currentURL.searchParams.get('error_description');

        // IMPORTANT
        // If a custom Auth0 rule fails, it will redirect to the client's /callback page with the error.
        // This error should be shown on the login page, so we redirect the user again for login, but now with the received error message.
        // We send it in the 'extraParams' property with the key 'errorMsg'.
        // DO NOT CHANGE IT UNLESS YOU KNOW WHAT YOU ARE DOING!
        // for more info please look into the Auth0 admin interface: Branding > Universal login (classic) > Login tab
        // Related info:
        // https://community.auth0.com/t/handling-authorization-error-with-hosted-pages/9931/5
        loginWithRedirect({ errorMsg });
      } else if (currentURL.searchParams.get('code')) {
        const { appState } = await handleRedirectCallback();
        onRedirectCallback(appState);
      } else if (currentURL.searchParams.get('access_token')) {
        // in case of cached frontends, the auth0-js version used 'access_token' but spa uses 'code'
        loginWithRedirect();
      }
    };

    if (
      isAuthenticated &&
      !loading &&
      history.location.pathname === '/callback'
    ) {
      history.replace('/mobile/trip');
      // checking loading is crucial here otherwise it is going to be called twice due to re-render of parent components
    } else if (!isAuthenticated && !loading) {
      fn();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <LoadingIndicator />;
};

export default Callback;
